import { Scope, VideofeedOrderBy, VideofeedStatus, VideofeedType } from '@common/clients/api';
import { VideofeedService } from '@common/clients/api/generated/sdk.gen';
import { createApiClient } from '@common/clients/request/api-client';
import type { ContextData } from '@common/defaults/ContextData';

export const fetchVideofeed = async ({
    contextData,
    feedType = VideofeedType.DEFAULT,
    status = VideofeedStatus.ACTIVE,
}: {
    contextData: ContextData;
    feedType?: VideofeedType;
    status?: VideofeedStatus;
}) => {
    const client = createApiClient({ contextData });

    const { data: response } = await VideofeedService.listVideofeedByDomainId({
        client,
        path: {
            contextID: contextData.context.id,
        },
        query: {
            orderBy: status === VideofeedStatus.ACTIVE ? VideofeedOrderBy.POSITION : undefined,
            scope: Scope.PUBLIC,
            status,
            feedType,
        },
        next: {
            revalidate: 10,
        },
    });
    return response?.data || [];
};
